import { i18next } from '@/i18n'

export default {
  path: 'contact/',
  meta: {
    auth: [
      'admin',
      'ROLE_USER'
    ],
    title: i18next.t('routes.contactManagerTitle')
  },
  component: () =>
    import(/* webpackChunkName: "contacts" */ '@/pages/contacts/Contacts.vue'),
  children: [
    {
      path: '',
      name: 'contacts',
      meta: {
        title: i18next.t('routes.contactsSynthesisTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "contacts" */ '@/pages/contacts/SyntheseContacts.vue'
        )
    },
    {
      path: 'contacts-all/',
      name: 'contacts-all',
      meta: {
        title: i18next.t('routes.contactsGeneratedTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "contacts" */ '@/pages/contacts/ContactsListAll.vue'
        )
    },
    {
      path: 'contacts-portals/',
      name: 'contacts-portals',
      meta: {
        title: i18next.t('routes.contactsGeneratedByPortalsTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "contacts" */ '@/pages/contacts/ContactsListPortals.vue'
        )
    },
    {
      path: 'detail-contacts-portals/:portal',
      name: 'contacts-portals-detail',
      meta: {
        title: i18next.t('routes.contactsDetailsPerPortalTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "contacts" */ '@/pages/contacts/DetailContactsPerPortal.vue'
        )
    },
    {
      path: 'contacts-posts/',
      name: 'contacts-posts',
      meta: {
        title: i18next.t('routes.contactsGeneratedByAdsTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "contacts" */ '@/pages/contacts/ContactsListPosts.vue'
        )
    },
    {
      path: 'contacts-visites/',
      name: 'contacts-visites',
      meta: {
        title: i18next.t('routes.contactsVisitesTitle')
      },
      component: () =>
          import(
            /* webpackChunkName: "contacts" */ '@/pages/contacts/ContactsVisites.vue'
          )
    },
    {
      path: 'detail-contacts-posts/:post',
      name: 'contacts-posts-detail',
      meta: {
        title: i18next.t('routes.contactsDetailsPerAdTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "contacts" */ '@/pages/contacts/DetailContactsPerPost.vue'
        )
    },
    {
      path: 'synthese-contacts',
      name: 'synthese-contacts',
      meta: {
        title: i18next.t('routes.contactsSynthesisTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "contacts" */ '@/pages/contacts/SyntheseContacts.vue'
        )
    },
    {
      path: 'detail-demandes-rapprochement/:portal',
      name: 'rapprochement-portals-detail',
      meta: {
        title: i18next.t('routes.demandeRapprochementDetailsPerPortalTitle')
      },
      component: () =>
        import(
          /* webpackChunkName: "contacts" */ '@/pages/contacts/ContactsListRapprochementPortals.vue'
        )
    }
  ]
}
